/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedMessageRequest
 */
export interface APIPatchedMessageRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIPatchedMessageRequest
     */
    eventData?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedMessageRequest
     */
    body?: string;
}

/**
 * Check if a given object implements the APIPatchedMessageRequest interface.
 */
export function instanceOfAPIPatchedMessageRequest(value: object): value is APIPatchedMessageRequest {
    return true;
}

export function APIPatchedMessageRequestFromJSON(json: any): APIPatchedMessageRequest {
    return APIPatchedMessageRequestFromJSONTyped(json, false);
}

export function APIPatchedMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'eventData': json['event_data'] == null ? undefined : json['event_data'],
        'body': json['body'] == null ? undefined : json['body'],
    };
}

export function APIPatchedMessageRequestToJSON(value?: APIPatchedMessageRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'event_data': value['eventData'],
        'body': value['body'],
    };
}

